import axios from 'axios';
import { IFile } from 'common/models';
import { IFileParams } from 'entities/File/File.models';

const basePath = 'files';

export const fileTransport = {
  downloadFile: (params: IFileParams): Promise<any> => axios.get(`${basePath}/${params.id}`, { responseType: 'blob' }),
  uploadFile: (formData: FormData): Promise<IFile> => axios.post(`${basePath}/upload`, formData),
};
